import React from 'react';

const PurchaseOrderCreateLabelListAdded = ({item, handleOnDelete}) => {
  return (
    <div className="overflow-scroll">
      <table className="table table-striped table-order-station datatable mb-0">
        <thead className="thead-inverse">
          <tr>
            <th>
              <span className="hidden-xs-down">Inventories</span>
              <span className="hidden-sm-up">Inv.</span>
            </th>
            <th className="hidden-xs-down">Barcode</th>
            <th>Qty</th>
            <th>Lot</th>
            <th>Packing Date</th>
            <th>Plant</th>
            <th>Price</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {item.labels.map((label, key) =>
            <tr key={key}>
              <td>{label.number_inventories || ' - '}</td>
              <td className="hidden-xs-down">{label.barcode || ' - '}</td>
              <td>{label.weight || ' - '} <span className="badge badge-pill badge-info">{item.measure_unit}</span></td>
              <td>{label.vendor_lot_number || ' - '}</td>
              <td>{label.packing_date || ' - '}</td>
              <td>{label.plant || ' - '}</td>
              <td>{label.price || ' - '}</td>
              <td><button className="btn btn-danger btn-sm" onClick={() => handleOnDelete(item.id, label.id)} ><i className="fa fa-trash"></i></button></td>
            </tr>
          )}
          {item.labels.length === 0 && <tr><td colSpan="8">No labels created yet</td></tr>}
        </tbody>
      </table>
    </div>
  )
}

export default PurchaseOrderCreateLabelListAdded